import { useMatch } from 'react-router';

export const useMatchAllCouriers = () => useMatch('/couriers');
export const useMatchCourierDetails = () => useMatch('/couriers/:courierId/*');
export const useMatchCourierGroups = () => useMatch('/courier-groups/*');
export const useMatchCourierOnboarding = () => useMatch('/courier-onboarding/*');
export const useMatchEarnings = () => useMatch('/earnings/*');
export const useMatchGeoLocation = () => useMatch('/geo-location');
export const useMatchGeoLocationHistory = () => useMatch('/geolocation-history');
export const useMatchLiveDeliveries = () => useMatch('/live-deliveries');
export const useMatchPerformance = () => useMatch('/performance/*');
export const useMatchSchedule = () => useMatch('/schedule/*');
export const useMatchOverview = () => useMatch('/overview/*');
export const useMatchSettings = () => useMatch('/settings/*');
export const useMatchDashboard = () => useMatch('/dashboard/*');
